module.exports = __webpack_public_path__ + "static/media/181.a7c919d6.webp";